exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/author-lab-manager.js-WebpackMultiOutput";